//IMPORTAÇÃO DAS BIBLIOTECAS---------------------------------------------------
import { useEffect, useState } from "react";
import { api } from "../../../../../services/api"; // Importação da API para requisições
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";




//IMPORTAÇÃO DOS COMPONENTES---------------------------------------------------
import styles from "./plano.module.css";
import ComponentLoad from "../../../../componentLoad/componentLoad.js";


//COMPONENTE-------------------------------------------------------------------
export default function Plano() {

    // VARIÁVEIS DE ESTADO-----------------------------------------------------

    // idiomas
    const { t } = useTranslation();

    // Estado para controlar o carregamento dos dados iniciais do usuário
    const [componentLoading, setComponentLoading] = useState(true); // loading do componente
    const [error, setError] = useState(false); // erro ao carregar dados iniciais
    const [validityPayment, setValidityPayment] = useState(true); // pagamento disponível caso o plano atual do usuário tenha validade inferior a 6 meses
    const [currentPlan, setCurrentPlan] = useState(null); // plano atual do usuário
    const [expiresAt, setExpiresAt] = useState(null); // data de vencimento do plano atual
    const [payPendingConfirmation, setPayPendingConfirmation] = useState(false); // pagamento pendente de confirmação
    const [expiredPlan, setExpiredPlan] = useState(false); // plano expirado



    // EFEITOS COLATERAIS------------------------------------------------------
    // efeito para buscar dados iniciais para a página como plano atual do usúario, preços e tipos de planos
    useEffect(() => {
        (async () => {
            try {
                const res = await api.get("/payments/getDataPlanUser");
                if (res?.data) {
                    setCurrentPlan(res.data.plano ?? "Nenhum");
                    setExpiresAt(res.data.expiration ?? null);
                    setPayPendingConfirmation(res.data.payPendingConfirmation ?? false);

                    // caso não possa comprar plano
                    if (res.data.validityPayment === false) {
                        setValidityPayment(false);
                    }

                    setComponentLoading(false);

                    // se plano expirado, mostrar mensagem
                    if (res.data.expiration) {
                        const expDate = new Date(res.data.expiration);
                        const now = new Date();
                        if (expDate < now) {
                            setExpiredPlan(true);
                        }
                    }

                }
            } catch (error) {
                console.error(error.response?.data ?? error.message);
                setError(true);
                setComponentLoading(false);
            }
        })();
    }, [validityPayment]);



    return (
        <>
            {/* Exibir spinner enquanto os dados estão sendo carregados */}
            {componentLoading ? (
                <div className={styles.spinnerContainer}>
                    <ComponentLoad />
                </div>
            ) : (
                <>
                    {/* se tiver erro, mostra mensagem */}
                    {error ? (
                        <div className={styles.errorPanel}>
                            <p>{t("Error loading plan data. Please try again!")}</p>
                        </div>
                    ) : (
                        <>
                            {/* Dados do plano atual */}
                            <section className={styles.currentPlan}>
                                <p><strong>{t("Active plan")}:</strong> {currentPlan}</p>
                                <p><strong>{t("Validity")}:</strong> {expiresAt ? new Date(expiresAt).toLocaleString() : "null"}</p>
                                {/* se plano expirado, mostrar mensagem */}
                                {expiredPlan &&
                                    <p style={{ color: "#da7c50ff" }}>{t("Your plan has expired. Please renew your plan to continue using the service!")}</p>
                                }
                                {payPendingConfirmation &&
                                    <p style={{ color: "#eb9b08ff" }}>{t("You have a pending payment confirmation. Please wait for processing!")}</p>
                                }
                            </section>

                            {/* so mostra os preferencesFroms se validityPayment for true*/}
                            {validityPayment ? (
                                <main>
                                    {/* link para a página de pagamento */}
                                    <div className={styles.preferencesForm}>
                                        <div className={styles.upgradeHeader}>
                                            <div className={styles.upgradeIconContainer}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={styles.upgradeIcon}>
                                                    <path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 8.25 3c1.933 0 3.737.957 4.75 2.457A5.968 5.968 0 0117.75 3c3.536 0 6 2.322 6 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" />
                                                </svg>
                                            </div>
                                            <h3 className={styles.upgradeTitle}>
                                                {currentPlan === 'FreeTrial' ? t("Upgrade your plan!") : t("Renew or Upgrade Your Plan")}
                                            </h3>
                                        </div>

                                        <p className={styles.upgradeDescription}>
                                            {t("plano.upgradeDescription")}
                                        </p>

                                        <div className={styles.benefitsList}>
                                            <div className={styles.benefitItem}>
                                                <svg className={styles.checkIcon} viewBox="0 0 20 20" fill="currentColor">
                                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
                                                </svg>
                                                <span>{t("plano.benefit1")}</span>
                                            </div>
                                            <div className={styles.benefitItem}>
                                                <svg className={styles.checkIcon} viewBox="0 0 20 20" fill="currentColor">
                                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
                                                </svg>
                                                <span>{t("plano.benefit2")}</span>
                                            </div>
                                        </div>

                                        <Link to="/payments" className={styles.upgradeButton}>
                                            {t("View Plans & Pricing")}
                                            <svg className={styles.arrowIcon} viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                                            </svg>
                                        </Link>
                                    </div>
                                </main>
                            ) : (
                                // se plano atual tiver validade superior a 1 ano, mostra mensagem de plano ativo!
                                <div className={styles.msgActivePlan}>
                                    <p>{t("Your plan is active. Enjoy all available features!")}</p>
                                </div>
                            )}
                        </>
                    )}
                </>
            )}
        </>
    );
}